import { IAppState } from '../../redux';

export function selectIsAutoProlongAvailable(state: IAppState): boolean {
  const {
    checkoutInfo: { autoProlongInfo },
  } = state;

  return autoProlongInfo.isAvailable;
}
